<template>
    <div >                    
        <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#dsrp" data-bs-target="#clTwo" aria-controls="clTwo" to="" aria-expanded="true"><h4 class="property_block_title">{{ $t('description') }}</h4></router-link>
            </div>
            <div id="clTwo" class="panel-collapse collapse show">
                <div class="block-body">
                    <p v-html="item && item?.description  ? item?.description  : ''"></p>
                </div>
            </div>
        </div>
                        
        <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#amen"  data-bs-target="#clThree" aria-controls="clThree" to="" aria-expanded="true"><h4 class="property_block_title">{{ $t('important products') }}</h4></router-link>
            </div>
            <div id="clThree" class="panel-collapse collapse show">
                <div class="block-body">
                    <ul>
                        <li v-for="name in productNames" :key="name">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="green" class="bi bi-check-circle py-1" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                            <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
                            </svg>{{name}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#vid" data-bs-target="#clFour" aria-controls="clFour" to="" aria-expanded="true" class="collapsed">
                    <h4 class="property_block_title">{{ $t('video for the company') }}</h4>
                </router-link>
            </div>
            <div id="clFour" class="panel-collapse collapse">
                <div class="block-body">
                    <div class="property_video">
                        <div class="thumb">
                            <img class="pro_img img-fluid w100" :src="pl6" alt="7.jpg">
                            <div class="overlay_icon">
                                <div class="bb-video-box">
                                    <div class="bb-video-box-inner">
                                        <div class="bb-video-box-innerup">
                                            <a href="#" @click="openModal(item.video_url)" data-bs-toggle="modal" data-bs-target="#popup-video" class="text-primary">
                                                <i class="fa-solid fa-play"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>                
        <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#floor"  data-bs-target="#clFive" aria-controls="clFive" to="" aria-expanded="true" class="collapsed"><h4 class="property_block_title">{{ $t('Company contact information') }}</h4></router-link>
            </div>
            <div id="clFive" class="panel-collapse collapse">
                <div class="block-body">
                    <div class="accordion" id="floor-option">
                        <div class="card">
                            <div class="card-header" id="firstFloor">
                                <h2 class="mb-0">
                                    <button type="button" class="btn btn-link" >{{ $t('email') }}<span>{{ item?.email || 'No email provided' }}</span></button>									
                                </h2>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="seconfFloor">
                                <h2 class="mb-0">
                                    <button type="button" class="btn btn-link">{{ $t('phone') }}<span>{{ item?.phone || 'No phone provided' }}</span></button>
                                </h2>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="third-garage">
                                <h2 class="mb-0">
                                    <button type="button" class="btn btn-link" >{{ $t('whatsapp') }}<span>{{ item?.whatsapp || 'No whatsapp provided' }}</span></button>                     
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                        
        <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#loca"  data-bs-target="#clSix" aria-controls="clSix" to="" aria-expanded="true" class="collapsed"><h4 class="property_block_title">{{ $t('location of the company') }}</h4></router-link>
            </div>
            <div id="clSix" class="panel-collapse collapse">
                <div class="block-body">
                    <div class="map-container" v-if="item?.location" v-html="item.location">
                    </div>
                </div>
            </div>
        </div>
        <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3560.3838103135677!2d80.87929001488125!3d26.827742183164247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfe8bc34b51bb%3A0xa3ca86eec63f6f8!2sINFOSYS%20DIGITAL%20COMPUTER%20(Prabhat%20Computer%20Classes)!5e0!3m2!1sen!2sin!4v1680238790732!5m2!1sen!2sin" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->
        <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#clSev" data-bs-target="#clSev" aria-controls="clSev" to="" aria-expanded="true" class="collapsed">
                    <h4 class="property_block_title">{{ $t('gallery') }}</h4>
                </router-link>
            </div>
            <div id="clSev" class="panel-collapse collapse">
                <div class="block-body">
                    <ul v-if="galleryList.length" class="list-gallery-inline">
                        <li v-for="(image, index) in galleryList" :key="index">
                                <img :src="image" class="img-fluid mx-auto" :alt="'Gallery image ' + (index + 1)" />
                        </li>
                    </ul>
                    <!-- <p v-else class="text-muted">لا توجد صور متاحة</p> -->
                </div>
            </div>
        </div>


        <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#comment" data-bs-target="#clTen" aria-controls="clTen" to="" aria-expanded="true"><h4 class="property_block_title">{{ $t('Message the company') }}</h4></router-link>
            </div>
            
            <div id="clTen" class="panel-collapse collapse show">
                <div class="block-body">
                    <!-- <form class="form-submit"> -->
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="form-group">
                                    <textarea class="form-control ht-80" v-model="desc" :placeholder="$t('messages')"></textarea>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="form-group">
                                    <input type="text" v-model="name" class="form-control" :placeholder="$t('your name')">
                                </div>
                            </div>
                            
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="form-group">
                                    <input type="email" v-model="email" class="form-control" :placeholder="$t('your email')">
                                </div>
                            </div>
                            
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="form-group">
                                        <button type="button" class="btn btn-primary fw-medium rounded full-width" @click="sendEmailMs">
                                            {{ $t('send') }}
                                        </button>                               
                                </div>
                            </div>
                        </div>
                    <!-- </form> -->
                </div>
            </div>
        </div>
        <div class="tags-row">
            <strong>{{ $t('Tags') }}:</strong>
            <span v-for="tag in item?.tags" :key="tag.id" class="tag-item">{{ tag.name }}</span>
        </div>
        <p><strong>{{ $t('Visitor Count') }}</strong> {{ props.visitorCount }}</p>
        <div class="modal fade" id="popup-video" tabindex="-1" role="dialog" aria-labelledby="popupvideo" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" id="popupvideo">
                    <iframe v-if="videoUrl" class="embed-responsive-item full-width" height="480" :src="videoUrl" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import '@vueform/multiselect/themes/default.css';
import pl6 from '@/assets/img/ruqm.webp'
import {computed,  defineProps, ref } from "vue";
import Swal from 'sweetalert2';
import { useI18n } from "vue-i18n"; 
import axios from "axios";
const props = defineProps({
item: {
    type: Object,
    required: true,
},
visitorCount: {
    type: Number,
    default: 0
}
});
const productNames = computed(() => {
    return props.item?.products?.map(product => product.name) || [];
});
const videoUrl = ref(null);

const openModal = (url) => {
if (url) {
    const videoId = url.split("v=")[1]?.split("&")[0]; 
    videoUrl.value = videoId ? `https://www.youtube.com/embed/${videoId}?rel=0` : '';
} else {
    videoUrl.value = '';
}
};
const galleryList = computed(() => {
    return props.item?.gallery?.filter(img => img) || []; 
}); 

const name = ref("");
const email = ref("");
const desc = ref("");
const { locale } = useI18n();

const { t } = useI18n(); 
const sendEmailMs = async () => {
    
try {
    await axios.post("/sendMS", {
    name: name.value,
    email: email.value,
    desc: desc.value,
    stand_email: props.item?.email,
    },{
    headers: {
        'Accept-Language': locale.value, 
    }
    });
    
    
    name.value = '';
    email.value = '';
    desc.value = '';

    Swal.fire({
    title: t('successTitle'),
    text: t('successText'),
    icon: 'success',
    confirmButtonText: t('ok'),
    customClass: {
        confirmButton: 'swal-btn-success',
    },
    });
} catch (error) {
    console.error("Error sending email:", error);
    
    Swal.fire({
    title: t('errorTitle'),
    text: t('errorText'),
    icon: 'error',
    confirmButtonText: t('tryAgain'),
    customClass: {
        confirmButton: 'swal-btn-error',
    },
    });
}
};
</script>
<style>
.swal-btn-success {
  background-color: #28a745; 
  color: white;
  border: none;
}

.swal-btn-success:hover {
  background-color: #218838;
}

.swal-btn-error {
  background-color: #dc3545;
  color: white;
  border: none;
}

.swal-btn-error:hover {
  background-color: #c82333;
}
.map-container iframe {
    width: 100% !important;
    height: 300px !important;
}
.tags-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-item {
  background-color: #6A715D;
  color: #fff;
  padding: 0px 10px;
  border-radius: 12px;
  font-size: 0.9rem;
}
</style>
